/**
 * ログイン後のホーム画面ルートを決定する。
 *
 * テーブルビュー(ホール/フロア)の有効無効やデフォルトビューは、
 * ここで判定しない。ナビゲーションには常に両方表示され、
 * 各画面が自分の前提(例: フロアはレイアウト設計済みか)を
 * 自己判定してリダイレクトする設計。
 */
export const getHomeRoute = (currentUser, currentClub) => {
  const userRole = currentUser && currentUser.role ? currentUser.role : null

  const routeNames = {
    admin: 'admin-home',
    waiter: 'waiter-halls',
    cast: 'cast-test',
    custom: 'waiter-halls',
  }
  const routeName = routeNames[userRole]

  if (!routeName || !currentClub?.slug) return { name: 'auth-login' }

  return { name: routeName, params: { club_slug: currentClub.slug } }
}
